import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid, Paper, Chip } from '@mui/material';
import { 
  FitnessCenter as FitnessCenterIcon, 
  WhatsApp as WhatsAppIcon,
  CheckCircle as CheckCircleIcon,
  Star as StarIcon,
  LocationOn as LocationOnIcon
} from '@mui/icons-material';
import { SOCIAL } from '../utils/constants';

// 1. IMPORTAÇÃO DAS IMAGENS DO CARROSSEL
import acao_2 from '../assets/acao_2.jpg';
import acao_4 from '../assets/acao_4.jpg';
import acao_5 from '../assets/acao_5.jpg';

const benefits = [
  "Anamnese detalhada e planejamento estratégico",
  "Avaliação física completa e guia de autoavaliação",
  "Montagem de treino personalizada e orientação",
  "1 Vídeo chamada semanal para ajustes finos e dúvidas",
  "Suporte contínuo e esclarecimento de dúvidas"
];

// Array com as imagens
const carouselImages = [acao_2, acao_4, acao_5];

const ServicesSection = () => {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => setActiveStep((prev) => (prev + 1) % carouselImages.length);

  useEffect(() => {
    const timer = setInterval(handleNext, 4000);
    return () => clearInterval(timer);
  }, []); 

  return (
    <Box id="servicos" sx={{ bgcolor: 'background.default', py: 8, width: '100%', px: { xs: 2, md: 5 }, overflowX: 'hidden' }}>
      
      {/* Cabeçalho da Seção */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 6, flexDirection: { xs: 'column', md: 'row' }, textAlign: { xs: 'center', md: 'left' } }}>
        <FitnessCenterIcon sx={{ fontSize: 40, color: 'primary.main', mr: { xs: 0, md: 2 }, mb: { xs: 1, md: 0 } }} />
        <Typography variant="h3" color="white">
          COMO POSSO TE AJUDAR?
        </Typography>
      </Box>

      <Grid container spacing={6} alignItems="center">
        
        {/* ==========================================
            COLUNA 1: CARROSSEL 
            Mobile: Fica no Meio (2) | Desktop: Fica na Esquerda (1)
        ========================================== */}
        <Grid item xs={12} md={5} sx={{ order: { xs: 2, md: 1 } }}>
          <Box 
            sx={{ 
              position: 'relative', 
              width: '100%', 
              maxWidth: 400, 
              mx: { xs: 'auto', md: 0 }, 
              borderRadius: 4, 
              overflow: 'hidden', 
              border: '2px solid #333',
              boxShadow: '0 10px 30px rgba(255, 214, 0, 0.2)' 
            }}
          >
            {/* Imagem */}
            <Box 
              component="img"
              src={carouselImages[activeStep]}
              alt={`Ação Mario Bento ${activeStep + 1}`}
              sx={{ 
                width: '100%', 
                height: 'auto', 
                display: 'block', 
                aspectRatio: '4/5', 
                objectFit: 'cover',
                transition: 'opacity 0.5s ease-in-out'
              }} 
            />

            {/* Pontinhos Indicadores (Dots) */}
            <Box sx={{ position: 'absolute', bottom: 16, width: '100%', display: 'flex', justifyContent: 'center', gap: 1 }}>
              {carouselImages.map((_, index) => (
                <Box 
                  key={index}
                  onClick={() => setActiveStep(index)} 
                  sx={{ 
                    width: activeStep === index ? 24 : 8, 
                    height: 8, 
                    bgcolor: activeStep === index ? 'primary.main' : 'rgba(255,255,255,0.5)', 
                    borderRadius: 4,
                    transition: 'all 0.3s ease',
                    cursor: 'pointer' 
                  }} 
                />
              ))}
            </Box>
          </Box>
        </Grid>


        {/* ==========================================
            COLUNA 2: COPYWRITING E LOCALIZAÇÃO
            Mobile: Fica no Topo (1) | Desktop: Fica na Direita (2)
        ========================================== */}
        <Grid item xs={12} md={7} sx={{ order: { xs: 1, md: 2 } }}>
          
          <Typography 
            variant="h4" 
            color="primary" 
            gutterBottom 
            sx={{ fontWeight: 700, textTransform: 'uppercase', textAlign: { xs: 'center', md: 'left' }, mb: 3 }}
          >
            Consultoria Online Premium
          </Typography>

          <Typography variant="h6" color="white" sx={{ mb: 3, fontWeight: 300, opacity: 0.9, textAlign: { xs: 'center', md: 'left' } }}>
            A metodologia de elite para quem não tem tempo a perder e busca resultados definitivos.
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ color: '#ccc', mb: 4, textAlign: { xs: 'center', md: 'left' } }}>
            Não é apenas uma ficha de treino. É um acompanhamento próximo, onde ajustamos sua rotina semanalmente para garantir que você continue evoluindo, independente dos imprevistos do dia a dia.
          </Typography>

          {/* Chips dos Planos */}
          <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
            <Typography variant="overline" color="gray" sx={{ letterSpacing: 2 }}>
              DISPONÍVEL NOS PLANOS
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap', justifyContent: { xs: 'center', md: 'flex-start' } }}>
              <Chip label="TRIMESTRAL" sx={{ bgcolor: 'rgba(255, 214, 0, 0.1)', color: 'primary.main', border: '1px solid #FFD600', fontWeight: 'bold', px: 2 }} />
              <Chip label="SEMESTRAL" sx={{ bgcolor: 'rgba(255, 214, 0, 0.1)', color: 'primary.main', border: '1px solid #FFD600', fontWeight: 'bold', px: 2 }} />
            </Box>
          </Box>

          {/* Bloco Presencial */}
          <Box 
            sx={{ 
              mt: 2, mb: { xs: 5, md: 0 }, p: 3, 
              borderLeft: '4px solid #fff', bgcolor: 'rgba(255,255,255,0.03)', borderRadius: '0 8px 8px 0',
              display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' }, textAlign: { xs: 'center', md: 'left' }
            }}
          >
              <Typography variant="h6" color="white" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', fontSize: '1.1rem' }}>
                <LocationOnIcon sx={{ mr: 1, color: 'white' }} />
                PREFERE TREINO PRESENCIAL?
              </Typography>
              <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 800, mt: 0.5, mb: 1, letterSpacing: 1, ml: { xs: 0, md: 4 } }}>
                DISPONÍVEL EM UBERABA - MG
              </Typography>
              <Typography variant="body2" color="#ccc" sx={{ mt: 1, lineHeight: 1.6 }}>
                Tenha um acompanhamento <strong>lado a lado</strong> na academia. Ideal para quem busca correção técnica minuciosa, segurança máxima e motivação extra durante a execução de cada exercício.
              </Typography>
          </Box>
        </Grid>


        {/* ==========================================
            LINHA DE BAIXO: CARD PREMIUM + BOTAO
            Fica na base em todos os dispositivos (3)
        ========================================== */}
        <Grid item xs={12} md={10} sx={{ order: 3, mt: { xs: 2, md: 4 }, mx: 'auto' }}>
          <Paper 
            elevation={4}
            sx={{ 
              p: { xs: 3, md: 5 }, 
              bgcolor: '#121212', 
              border: '1px solid #333', borderTop: '4px solid #FFD600', borderRadius: 2,
              position: 'relative', overflow: 'hidden'
            }}
          >
            <Box sx={{ position: 'absolute', top: -20, right: -20, opacity: 0.05, transform: 'rotate(15deg)' }}>
              <StarIcon sx={{ fontSize: 180, color: 'white' }} />
            </Box>

            <Typography variant="h5" color="white" gutterBottom sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'center' }, fontWeight: 'bold' }}>
              <StarIcon color="primary" sx={{ mr: 1, fontSize: 30 }} />
              ONLINE PREMIUM INCLUI:
            </Typography>

            <Grid container spacing={3}>
              {benefits.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', color: '#e0e0e0', fontSize: '1.1rem' }}>
                    <CheckCircleIcon color="primary" sx={{ mr: 2, mt: 0.5, fontSize: 22 }} />
                    <Typography variant="body1" sx={{ lineHeight: 1.4, textAlign: 'left' }}>
                      {index === 3 ? <Box component="span" sx={{ color: 'white', fontWeight: 'bold' }}>{item}</Box> : item}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Botão Único e Centralizado abaixo do Card */}
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 6 }}>
            <CtaButton />
          </Box>
        </Grid>

      </Grid>
    </Box>
  );
};

// Componente do Botão Modernizado
const CtaButton = () => (
  <Button 
    variant="contained" 
    color="primary" 
    size="large" 
    startIcon={<WhatsAppIcon />}
    href={SOCIAL.whatsapp}
    target="_blank"
    sx={{
      fontWeight: 800, // Deixei o texto um pouco mais encorpado
      fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }, // Menor no celular, grande no PC
      padding: { xs: '12px 24px', md: '16px 40px' }, // Menos espaçamento lateral no celular
      borderRadius: '50px', // Formato de pílula arredondada (Moderno)
      whiteSpace: 'nowrap', // Impede o texto de quebrar de linha
      letterSpacing: { xs: 0.5, md: 1 },
      boxShadow: '0 8px 20px rgba(255, 214, 0, 0.4)',
      width: 'auto', 
      transition: 'all 0.3s ease',
      '&:hover': { 
        transform: 'translateY(-3px) scale(1.02)', // Botão cresce e "flutua" ao passar o mouse
        boxShadow: '0 12px 30px rgba(255, 214, 0, 0.7)' 
      }
    }}
  >
    FALE DIRETO COMIGO
  </Button>
);

export default ServicesSection;